<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1QbL05/media/FC-9781685622978.jpg?1689450778582" alt="This image is the cover for the book In the Shadow of the Bridge"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">In the Shadow of the Bridge
      </h1>
      <p class="bookDescription body article font2">
        <p style='margin:0cm;font-size:15px;font-family:"Grotesque Light",sans-serif;'><span style="font-size:16px;">El closed her eyes and drew into the corner against the rock-clay bank and the rough boards. She could hear water dripping inside the mine shaft, could smell the dankness, feel the cold air being drawn through the cracks between the boards; she could picture Hollie as she had seen her running up the road in her yellow dress, breaking free, running, the yellow dress pressed against her thighs, starlight sliding along her arms and legs, flowing over her long gold hair, white-faced, doe-eyed, and frightened. She opened her eyes and gasped, alarmed by the sounds of a struggle close at hand. They had reached the railroad tracks, and Emmett was blocking the way. There was nowhere for Hollie to run except out onto the bridge.</span></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Betty Roberts
      </h2>
      
      <p class="authorDescription body article"><p style="font-size: 13px; font-family: Calibri, sans-serif; margin: 0mm; text-align: justify;"><span style='font-size:15px;font-family:"Times New Roman",serif;'>Betty Roberts was born in Wyoming County, West Virginia, graduated high school at Matoaka High, followed by graduation from the University of Virginia School of Nursing in Charlottesville, Virginia. Betty had an active career as a nurse, working in the delivery room or as a General Supervisor, with the last eight years of her nursing career spent in long term care. Betty also attended the University of Alabama in Huntsville and in Tuscaloosa, concentrating on her first love, writing. After retiring, Betty studied oil painting and with seven children and numerous grands and greats, she has no problem getting rid of her paintings. Betty spends her time writing, painting and enjoying her large family. Her other works: <em>Leaning into the Wind: The Wilderness of Widowhood</em> (under the name of Betty Bryant), <em>Midnight Chronicles: A Love Story </em>by Betty Roberts, <em>Cave-In</em> a short story published in the Scribbler, University of Alabama in Huntsville Magazine (under the name of Betty Osborne) and her latest book <em>Still Climbing</em> published under the name Betty Roberts.</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?03edd3ac